import React from 'react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom'; 

const Footer = ({ onNavigate }) => { 
  return (
    <footer className={styles.footer}> {/* Changed to <footer> for semantic clarity */}
      <div className={styles.footerContent}> 
        <div className={styles.socialIcons}> 
          <a href="https://www.facebook.com/crossedpathsofficial/" target="_blank" rel="noopener noreferrer">
            <svg className={styles.icon}>
              <use href="/FacebookLogo.svg#icon" /> 
            </svg>
          </a>
          <a href="https://twitter.com/your-x-profile" target="_blank" rel="noopener noreferrer">
            <svg className={styles.icon}>
              <use href="/XLogo.svg#icon" /> 
            </svg>
          </a>
          <a href="https://www.instagram.com/your-instagram-profile" target="_blank" rel="noopener noreferrer">
            <svg className={styles.icon}>
              <use href="/InstagramLogo.svg#icon" /> 
            </svg>
          </a>
        </div>
        <div className={styles.links}>
        <button onClick={() => onNavigate('terms-and-conditions')}>Terms & Conditions</button>
        {'    '}
        <button onClick={() => onNavigate('privacy-policy')}>Privacy Policy</button>

        </div>
      </div>
    </footer>
  );
};

export default Footer;